import React from 'react';
import { cloneDeep } from 'lodash';

import { api } from '../../../services/api';
import ModalWrapper from '../../base/modals/modal-wrapper';

import './styles/unlink-modal.scss';

const UnlinkModal = ({ setShowModal, userData, accountType, accountId, setUsers, company }) => {
  function handleSubmit() {
    api.delete(`/api/v0/users/${userData.uid}/${accountType}s/${accountId}/`).then(res => {
      setUsers(prevState => {
        const newUsers = cloneDeep(prevState);
        return newUsers.filter(user => user.uid !== userData.uid);
      });
      setShowModal(false);
    });
  }

  return (
    <div className="unlink-modal">
      <ModalWrapper closeModal={() => setShowModal(false)}>
        <h1>Remove User</h1>
        <div className="message">
          {`Remove the user ${userData.first_name} ${userData.last_name} (${userData.email})
					from ${company}`}
          ?
        </div>
        <div className="btns">
          <button className="cancel" onClick={() => setShowModal(false)}>
            Cancel
          </button>
          <button className="remove" onClick={handleSubmit}>
            Remove
          </button>
        </div>
      </ModalWrapper>
    </div>
  );
};

export default UnlinkModal;
